import { Component, ViewChild } from '@angular/core'
import { FieldType, FormlyFieldConfig } from '@ngx-formly/core'
import { Slider } from 'primeng/slider'
import { Subject } from 'rxjs'

@Component({
  selector: 'basin-formly-slider',
  templateUrl: './formly-slider.component.html',
  styleUrls: ['./formly-slider.component.scss'],
})
export class FormlySliderComponent extends FieldType {
  @ViewChild('slider') slider: Slider

  ngAfterViewInit() {
    const sliderReference$ = this.props.sliderReference as Subject<Slider>
    sliderReference$ && sliderReference$.next(this.slider)
  }

  actionDescriptionClicked(event: Event) {
    const actionDescriptionClicked$ = this.props
      .actionDescriptionClicked as Subject<{
      field: FormlyFieldConfig
      event: Event
    }>
    actionDescriptionClicked$ &&
      actionDescriptionClicked$.next({ field: this.field, event })
  }
}
